export default "__VITE_ASSET__DBLeRTH3__"